import { Link } from 'react-router-dom';

export const ConditionalLink = ({ children, to, condition, className }) => (!!condition && to)
      ? <Link to={to} className={className}>{children}</Link>
      : '';